import PaymentIframe from './PaymentIframe';

export default PaymentIframe;
